import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';
import DownloadCloudIcon from 'icons/DownloadCloud.icon';
import PdfImage from 'assets/images/pdf.webp';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { NEW_WINDOW_PROPS } from 'data/global';
import { isDataRoomViewer } from 'router/subrouters/DataRoom/utils';

import './SecureDownloadBadge.styles.scss';
import './SecureDownloadBadge.styles.responsive.scss';

const ADOBE_LINK = 'https://get.adobe.com/uk/reader/';

const SecureDownloadBadge: React.FC = () => {
  const { t } = useTranslation();

  const { isBuySide, role } = useContext(DataRoomContext);

  if (!isBuySide || isDataRoomViewer(role)) return null;

  return (
    <a
      className="secure-download-badge"
      href={ADOBE_LINK}
      {...NEW_WINDOW_PROPS}
    >
      <ResolveImage src={PdfImage} />

      <div>
        <p>{t('secureDownloads')}</p>
        <p>
          {t('secureDownloadsDescription')} <DownloadCloudIcon />
        </p>
      </div>
    </a>
  );
};

export default SecureDownloadBadge;
